/**
 * E-commerce measurement metrics customized by the marketing department based on the business
 */
export enum GaMetricsCustom {
  /**
   * 交易流程跟踪指标
   */
  transaction = 'transaction',
  track_event = 'trackEvent',
  add_to_cart = 'addToCart',
  checkout = 'checkout',
}
